// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + "7b43f5e8" + ".js";
};